module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_tvb_black_vertical-095cb5226a4bb96533039c5a03b91eeb.svg";